export class CombosClass {

    allCombos:any = {
        Array:require('./array/Array.tsx').default,
        Simple:require('./simple/Simple.tsx').default,
        SideBySide:require('./sideBySide/SideBySide').default,
        VTimeline:require('./VTimeline/VTimeline').default,
        Empty:require('./empty/Empty').default,
        Tabs:require('./tabs/Tabs').default,
        // Narrator:require('./narrator/Narrator').default,
    };

    getComboClass(elementName:string) {
        return this.allCombos[elementName];
    }

}

export default CombosClass;

